import React from 'react'
import Form from '../components/Form'
import Footer from '../components/Footer'
import Nav from '../components/Nav'
const Inquiry = () => {
  return (
     <div>
       
        <div className="h-3/4 bg bg-cover bg-center">
        <div className="h-full z-10 overlay">
          <Nav/>
          <div className="container landing mx-auto z-10 text-center text-white">
            <p className="text-4xl">INQUIRY NOW</p>
          </div>
          </div>
          </div>
          <div className="container  mx-auto w-full my-20 ">
            <div className="md:w-1/2 bg-[#fde7e7] mx-auto">
            <h1 className="text-5xl text-center md:m-10 p-4 pt-6">Get Inquiry</h1>
          <Form/></div></div>
          <Footer/>
          </div>
  )
}

export default Inquiry